'use strict';

export default function BannerCreateRequest ({onClick}) {
    
    const handleClick = () => {
        onClick && onClick();
    }
    
    return <div className="app-create">
        <div className="app-create__text">
            <h3>{tMsg('Создайте заявку и следите за ценой!')}</h3>
            <p>{tMsg('Отправим уведомление, когда цена по вашему запросу изменится')}</p>
        </div>
        <div className="app-create__btn">
            <button className="button button-base" onClick={handleClick}>
                {tMsg('Создать заявку')}
            </button>
        </div>
    </div>
}
